import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import PolitykaPrv from '../../elements/PolitykaPrv';
import FooterOne from '../../common/footer/FooterOne';

const PolitykaPrywatnosci = () => {
    return (
        <>
        <HeaderOne />
        
        <PolitykaPrv />
                
        <FooterOne />
        </>
    )
}
    
export default PolitykaPrywatnosci ;